import React from 'react'

const Popup = ({children, title, setClose} : any) => {
  return (
    <div className='popup_background'>
        <div className='popup'>
            <div className="popup__header">
                <h2>{title}</h2>
                <button onClick={() => setClose()}>x</button>
            </div>
            {children}
        </div>
    </div>
  )
}

export default Popup